import { ComponentPropsWithoutRef, forwardRef, MouseEvent, useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import cn from 'classnames';

type Props = {
  title: string;
  matchedPath: string[];
  iconClassName?: string;
  iconSrc?: string;
  showBadge?: boolean;
} & ComponentPropsWithoutRef<'li'>;

const LNBSubMenu = forwardRef<HTMLLIElement, Props>(
  ({ title, matchedPath, iconClassName = '', iconSrc, showBadge = false, onClick, children, ...props }, ref) => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const isCurrentLocation = matchedPath.some((path) => matchPath(path, location.pathname));

    const onClickToggle = (e: MouseEvent<HTMLLIElement>) => {
      e.preventDefault();
      onClick?.(e);

      if (children) {
        setIsOpen((prev) => !prev);
      }
    };

    useEffect(() => {
      setIsOpen(isCurrentLocation);
    }, [location]);

    return (
      <li className={cn({ open: isOpen, on: isCurrentLocation })} onClick={onClickToggle} {...props} ref={ref}>
        <a href="#none" className="link_snb">
          <span
            role="img"
            className={iconClassName}
            style={{ ...(!!iconSrc && { backgroundImage: `url(${iconSrc})` }) }}
          ></span>
          {title}
          {showBadge && <span className="ico_new">new</span>}
          <span className="ico_wallet ico_arr"></span>
        </a>
        <ul className="sub_snb">{children}</ul>
      </li>
    );
  }
);

LNBSubMenu.displayName = 'LNBSubMenu';

export default LNBSubMenu;
